import React from 'react'
import { Modal } from 'react-bootstrap'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { cloneDeep } from 'lodash'
import { useTranslation } from 'react-i18next'
import styled, { useTheme } from 'styled-components'
import { hoursArray } from '../../utils/hoursAndMinutes'
import { useAppointmentsAdministrationState } from '../../stores/Administration/AppointmentsAdministrationProvider'
import DailyAppointmentsOverview from './DailyAppointmentsOverview'


const StyledModal = styled(Modal)`
  .modal-dialog {
    max-width: 95vw;
  }
  .modal-content {
    height: 90vh;
    border: none;
    border-radius: 8px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  }
  .modal-header {
    background-color: ${(props) => props.$primaryColor || '#3a3a38'};
    color: white;
    border-radius: 8px 8px 0 0;
    padding: 1rem 1.5rem;
    border-bottom: none;

    .modal-title {
      font-size: 1rem;
      font-weight: 600;
      letter-spacing: 0.3px;
      color: white;
    }

    .btn-close {
      filter: invert(1) grayscale(100%) brightness(200%);
      opacity: 0.8;
      &:hover {
        opacity: 1;
      }
    }
  }
  .modal-body {
    background-color: #f8f8f8;
    padding: 1.5rem;
    overflow: hidden;
  }
`

const DailyAppointmentsCompareModal = () => {
  const { selectedDays, showDailyAppointmentsCompareModal, setShowDailyAppointmentsCompareModal, bookingSlots } = useAppointmentsAdministrationState();
  const { t } = useTranslation()
  const theme = useTheme()

  const responsive = {
    desktop: {
      breakpoint: { max: 4000, min: 1366 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1365, min: 992 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 991, min: 0 },
      items: 1,
    }
  };

  const handleClose = () => setShowDailyAppointmentsCompareModal(false);

  // filters the booking slots for an individual day and renders the event calendar for it
  const renderSelectedDay = (startTime, index) => {
    let selectedDate = startTime.slice(0, 10); // gets the selected date for the calendar in format '2021-10-21'
    let filteredBookingSlots = bookingSlots.filter(slot => slot.startTime.includes(selectedDate) && (slot.status === 'isAppointment' || slot.isLocked)); // && slot.status === 'isAppointment', add condition later

    let hoursArrayCopy = cloneDeep(hoursArray);
    filteredBookingSlots.forEach(slot => {
      let hour = parseInt(slot.startTime.substring(11, 13));
      hoursArrayCopy[hour].push(slot);
    });

    return (
      <div key={index} style={{ padding: '0 6px' }}>
        <div style={{ background: 'white', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
          <DailyAppointmentsOverview
            date={selectedDate}
            selectedDateHoursArray={hoursArrayCopy}
            showSimpleHeader={true}
          />
        </div>
      </div>
    )
  }

  return (
    <StyledModal
      size="xl"
      show={showDailyAppointmentsCompareModal}
      onHide={() => handleClose()}
      $primaryColor={theme.primaryColor}
    >
      <Modal.Header closeButton>
        <Modal.Title>{t('appointment:appointmentComparison')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {
          selectedDays.length ? <div>
            <Carousel
              responsive={responsive}
              swipeable={true}
              draggable={false}
            >
              {
                selectedDays.map((day, index) => renderSelectedDay(day[0], index))
              }
            </Carousel>
          </div>
            : null
        }
      </Modal.Body>
    </StyledModal>
  )
}

export default DailyAppointmentsCompareModal